<template>
  <div class="exchange_user">
    <h3>신청자</h3>
    <dl>
      <dt>사업자 유형​</dt>
      <dd>개인​</dd>
    </dl>
    <dl>
      <dt>이름</dt>
      <dd>{{ exchangeInit.userName }}</dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters('exchange', ['exchangeInit']),
  },
};
</script>
<style lang="scss"></style>
